// extracted by mini-css-extract-plugin
module.exports = {"container":"Video_container__1BNZY","cap":"Video_cap__2coEJ","fullHeight":"Video_fullHeight__1YDXb"};